import { createAction } from '@reduxjs/toolkit';

export const show = createAction('loader/show');
export const hide = createAction('loader/hide');
